<body class="body">
  <section class="header">
    <div class="div-block-4">
      <img src="/assets/logos/movline-logo-white.png" loading="lazy" width="207" alt="">
    </div>
  </section>
  
  <div class="step-1">
    <div class="success-container">
      <div class="success-icon-wrapper">
        <div class="success-icon">
          <i class="fas fa-check-circle"></i>
        </div>
        <div class="success-animation">
          <div class="success-ripple"></div>
          <div class="success-ripple"></div>
          <div class="success-ripple"></div>
        </div>
      </div>
      
      <h1 class="heading">Vielen Dank für Ihre Anfrage!</h1>
      <p class="paragraph mb-3">Wir suchen für Sie die besten Partnerfirmen</p>
      
      <div class="success-steps">
        <div class="step-item">
          <div class="step-icon">
            <i class="fas fa-search"></i>
          </div>
          <div class="step-content">
            <h3>Prüfung & Veröffentlichung</h3>
            <p>Ihre Anfrage wird von unserem Team geprüft und auf der Movline Plattform publiziert</p>
          </div>
        </div>
        
        <div class="step-item">
          <div class="step-icon">
            <i class="fas fa-envelope"></i>
          </div>
          <div class="step-content">
            <h3>5 Offerten per E-Mail</h3>
            <p>Sie erhalten qualifizierte Angebote von geprüften Partnerfirmen zum Vergleichen</p>
          </div>
        </div>
        
        <div class="step-item">
          <div class="step-icon">
            <i class="fas fa-mouse-pointer"></i>
          </div>
          <div class="step-content">
            <h3>Online bestätigen</h3>
            <p>Wählen Sie das beste Angebot aus und bestätigen Sie es mit nur einem Klick</p>
          </div>
        </div>
      </div>
      
      <div class="support-section">
        <div class="support-card">
          <div class="support-icon">
            <i class="fas fa-headset"></i>
          </div>
          <div class="support-content">
            <h4>Fragen? Wir helfen gerne!</h4>
            <p>Bei Fragen wenden Sie sich an unser 
              <a href="https://www.movline24.ch/kontakt" target="_blank" class="support-link">Support Team</a>
            </p>
          </div>
        </div>
      </div>
      
      <div class="action-buttons">
        <a href="https://www.movline24.ch/" class="submit-button primary-button">
          <span>Zurück zur Webseite</span>
          <i class="fas fa-arrow-right"></i>
        </a>
      </div>
    </div>
  </div>
</body>


<!-- http://localhost:4200/inquiry/success -->